{
  "version": 1,
  "asset_id": "badf956b-aa65-41b5-81cf-d59cc7aba8de",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/badf956b-aa65-41b5-81cf-d59cc7aba8de/openai.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/badf956b-aa65-41b5-81cf-d59cc7aba8de/openai.svg",
  "original_filename": "openai.svg",
  "size": 2946,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:58Z"
}
